@if (process) {
  <div class="card mb-3">
    <div class="card-header">
      {{ 'authenticated.quality-management.processes.edit.documents.header' | translate }}
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          @if (processVersion) {
            <app-table
              id="dashboard.quality-management.processes.versions.documents.index"
              [replaceParametersInUrl]="{'{process}': process.id, '{version}': processVersion.id}"
              [showBorder]="false"
              [showFavorites]="false"
              [showEditLink]="false"
              [showTopRow]="false"
              [isSubtable]="true"
              [functionList]="showFunctionList"
              [putTableParametersInUrl]="false"
            ></app-table>
          } @else {
            <app-table
              id="dashboard.quality-management.processes.documents.index"
              [replaceParametersInUrl]="{'{process}': process.id}"
              [showBorder]="false"
              [showFavorites]="false"
              [showEditLink]="false"
              [showTopRow]="false"
              [isSubtable]="true"
              [reloadEmitter]="reloadTable$"
              [functionList]="editFunctionList"
              [putTableParametersInUrl]="false"
            ></app-table>
          }
        </div>

        @if (processVersion === undefined) {
          <div class="col-12 d-flex justify-content-end">
            <app-private-file-upload-field
              layout="btn-only"
              itemName="Dokument"
              uploadTriggerType="on-change"
              [uploadPushTrigger$]="uploadFile$"
              [privateAttachments]="process.documents ?? []"
              [privateAttachmentAttachableId]="process.id"
              [privateAttachmentAttachableType]="PrivateAttachmentAttachableTypeEnum.PROCESSES"
              [privateAttachmentType]="PrivateAttachmentTypeEnum.QM_DOCUMENT"
              [privateAttachmentMeta]="process?.meta?.private_attachments"
              (uploadFinished)="fileUploadFinishedTrigger()"
              btnTranslateKey="authenticated.quality-management.processes.edit.documents.upload_btn"
            ></app-private-file-upload-field>
          </div>
        }
      </div>
    </div>
  </div>
}
